import React from 'react';

import { GoHubot } from 'react-icons/go';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import MarketBotList from './MarketBotList';

const NoUsersRecords = () => {
  const { t } = useTranslation();

  return (
    <>
      <MarketBotList />
      <div className="text-center p-5">
        <GoHubot size={200} color="#ccc" />
        <p className="mt-3">{t('bots.no_entries')}</p>

        <p>
          <Link className="btn btn-primary btn-lg shadow" to="/marketplace">
            Explorar Robôs
          </Link>
        </p>
      </div>
    </>
  );
};

export default NoUsersRecords;
